import axios from "axios";
import { toast } from "react-toastify";
import { UserDetailsApi, UserPermission } from ".";

export const fetchUserDetails = () => {
  const token = localStorage.getItem("token");
  return axios.get(`${UserDetailsApi}`).then((res) => {
    const user = res.data;
    if (
      user.user_selected_columns == "" ||
      user.user_selected_columns == {} ||
      user.user_selected_columns == []
    ) {
      user.user_selected_columns = {};
    } else {
      user.user_selected_columns = JSON.parse(user.user_selected_columns);
    }
    return user;
  });
};

export const fetchUserPermissions = () => {
  return axios.get(`${UserPermission}`).then((res) => {
    return res.data;
  });
};
